export const ICON_COLORS = [
  '#3996f3',
  '#314c5d',
  '#fad165',
  '#85b44a',
  '#8c5cfd',
  '#46c1d3',
  '#e23e57',
  '#989898',
  '#1b499e',
  '#f5856d',
  '#d9d9d9',
  '#ffff66',
  '#ffffff'
]

export const getIconSections = (t) => [
  {
    label: t('menu.general'),
    icons: [
      'mdi mdi-alert-outline',
      'mdi mdi-bell-ring-outline',
      'mdi mdi-alarm',
      'mdi mdi-alert-rhombus-outline',
      'mdi mdi-bell-alert-outline',
      'mdi mdi-car-brake-alert',
      'mdi mdi-alert-circle-outline',
      'mdi mdi-alert-octagon-outline',
      'mdi mdi-alert-decagram-outline',
      'mdi mdi-alert-box-outline',
      'mdi mdi-weather-cloudy-alert',
      'mdi mdi-alarm-multiple',
      'mdi mdi-bell-circle-outline',
    ]
  },
  {
    label: t('label_Alarms'),
    icons: [
      'mdi mdi-exit-run',
      'mdi mdi-exit-to-app',
      'mdi mdi-fire',
      'mdi mdi-fire-extinguisher',
      'mdi mdi-air-horn',
      'mdi mdi-fire-hydrant',
      'mdi mdi-water-alert-outline',
      'mdi mdi-water-remove-outline',
      'mdi mdi-pipe-leak',
      'mdi mdi-ambulance',
      'mdi mdi-medical-bag',
      'mdi mdi-hospital-box-outline',
      'mdi mdi-zodiac-aquarius',
      'mdi mdi-wrench-outline',
      'mdi mdi-server-off',
      'mdi mdi-lan-disconnect',
      'mdi mdi-alarm-light-outline',
    ]
  },
  {
    label: t('label_Danger'),
    icons: [
      'mdi mdi-alarm-light-outline',
      'mdi mdi-hazard-lights',
      'mdi mdi-triforce',
      'mdi mdi-molecule-co2',
      'mdi mdi-flash-alert-outline',
      'mdi mdi-bottle-tonic-skull-outline',
      'mdi mdi-skull-crossbones-outline',
      'mdi mdi-skull',
      'mdi mdi-virus-outline',
      'mdi mdi-bacteria-outline',
    ]
  },
  {
    label: t('label_Security'),
    icons: [
      'mdi mdi-shield-alert-outline',
      'mdi mdi-shield-key-outline',
      'mdi mdi-account-alert-outline',
      'mdi mdi-security-network',
      'mdi mdi-security',
      'mdi mdi-lock-open-alert',
      'mdi mdi-lock-open-outline',
      'mdi mdi-key-outline',
      'mdi mdi-key-remove',
      'mdi mdi-home-alert',
      'mdi mdi-home-lock-open',
      'mdi mdi-window-shutter-alert',
      'mdi mdi-volume-off',
    ]
  },
  {
    label: t('label_Maintenance'),
    icons: [
      'mdi mdi-broom',
      'mdi mdi-rake',
      'mdi mdi-hammer-wrench',
      'mdi mdi-wrench-outline',
    ]
  },
  {
    label: t('label_IT'),
    icons: [
      'mdi mdi-help-circle-outline',
      'mdi mdi-lan-disconnect',
      'mdi mdi-server-off',
      'mdi mdi-desktop-classic',
      'mdi mdi-content-save-alert-outline',
      'mdi mdi-disc-alert',
      'mdi mdi-timeline-alert-outline',
      'mdi mdi-folder-key-outline',
      'mdi mdi-folder-alert',
      'mdi mdi-table-alert',
      'mdi mdi-wifi-strength-alert-outline',
      'mdi mdi-restart-alert',
    ]
  },
  {
    label: t('label_Info_Calendar'),
    icons: [
      'mdi mdi-information-outline',
      'mdi mdi-information-variant',
      'mdi mdi-clock-alert-outline',
      'mdi mdi-calendar-alert',
      'mdi mdi-exclamation',
      'mdi mdi-exclamation-thick',
      'mdi mdi-clipboard-alert-outline',
      'mdi mdi-sticker-alert-outline',
      'mdi mdi-coffee-outline',
    ]
  },
  {
    label: t('label_Traffic'),
    icons: [
      'mdi mdi-bus-alert',
      'mdi mdi-subway-alert-variant',
      'mdi mdi-traffic-light',
    ]
  },
  {
    label: t('label_Technical'),
    icons: [
      'mdi mdi-coolant-temperature',
      'mdi mdi-radioactive',
      'mdi mdi-printer-3d-nozzle-alert-outline',
      'mdi mdi-tray-alert',
      'mdi mdi-beaker-alert-outline',
      'mdi mdi-water-percent-alert',
      'mdi mdi-thermometer-alert',
      'mdi mdi-thermometer-lines',
      'mdi mdi-oil-level',
      'mdi mdi-dishwasher-alert',
      'mdi mdi-battery-alert-variant-outline',
      'mdi mdi-vibrate',
      'mdi mdi-watch-vibrate',
      'mdi mdi-fuse-alert',
      'mdi mdi-engine-outline',
      'mdi mdi-fridge-alert-outline',
      'mdi mdi-state-machine',
      'mdi mdi-gas-cylinder',
      'mdi mdi-diving-scuba-tank',
      'mdi mdi-fan-alert',
      'mdi mdi-lightbulb-on-outline',
      'mdi mdi-power-plug-off-outline',
      'mdi mdi-car-tire-alert',
      'mdi mdi-lightning-bolt-outline',
      'mdi mdi-transmission-tower',
      'mdi mdi-scale-balance',
    ]
  },
  {
    label: t('label_Weather'),
    icons: [
      'mdi mdi-snowflake-alert',
      'mdi mdi-snowflake-melt',
      'mdi mdi-weather-cloudy-alert',
      'mdi mdi-weather-lightning',
      'mdi mdi-weather-pouring',
    ]
  },
  {
    label: t('label_media'),
    icons: [
      'mdi mdi-book-open-variant',
      'mdi mdi-cellphone-basic',
      'mdi mdi-cellphone',
      'mdi mdi-monitor',
      'mdi mdi-alarm-light-outline',
      'mdi mdi-phone-in-talk',
      'mdi mdi-email',
      'mdi mdi-card-text-outline',
      'mdi mdi-cellphone-text',
      'mdi mdi-message-text',
      'mdi mdi-cellphone-wireless',
      'mdi mdi-message-video',
      'mdi mdi-application-import',
      'mdi mdi-database-import',
      'mdi mdi-phone-voip',
      'mdi mdi-application-export',
      'mdi mdi-printer',
      'mdi mdi-database-export',
      'mdi mdi-motion-sensor',
      'mdi mdi-switch',
      'mdi mdi-serial-port',
      'mdi mdi-lighthouse',
      'mdi mdi-lighthouse',
      'mdi mdi-led-on',
      'mdi mdi-cup-water',
      'mdi mdi-gesture-tap-hold',
    ]
  }
]
